import { stringArrayToObject } from '~utils/array';
import energyIcon from '~assets/ic_general_energy_gray.svg';
import transportIcon from '~assets/ic_general_truck_gray.svg';
import boundaryIcon from '~assets/ic_general_borders_gray.svg';
import telecommunicationsIcon from '~assets/ic_general_communications.svg';

export const TYPES_LIST = ['event', 'project'];
export const TOPICS_LIST = ['energy', 'transport', 'boundary', 'telecommunications'];

export const TYPES = stringArrayToObject(TYPES_LIST);
export const TOPICS = stringArrayToObject(TOPICS_LIST);

export const TOPICS_ICON = {
  [TOPICS.energy]: energyIcon,
  [TOPICS.transport]: transportIcon,
  [TOPICS.boundary]: boundaryIcon,
  [TOPICS.telecommunications]: telecommunicationsIcon
};
